import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment.prod';

export interface Winner {
  id: number;
  priceWon: string;
}

export interface ReportsWinner {
  id: number;
  promotionDate: string;
  policyNo: string;
  priceWon: string;
  customerName: string;
  customerPhone: string;
  location: string;
  vrn: string;
  ownerName: string
}

export interface CreatePromotionPayload {
  name: string;
  vouchers: Voucher[];
  startDate: string;
  endDate: string;
}

export interface Voucher {
  name: string;
  amount: number;
  weight: number;
}

export interface CreateNewVoucherPayload {
  name: string;
  amount: number;
  weight: number;
  promotionId: number;

}
@Injectable({
  providedIn: 'root'
})
export class PromotionsService {
  http = inject(HttpClient);

  private baseUrl = environment.apiUrl + '/api/promotion-report-upload';

  fetchPromotionWinners({ dateFrom, dateTo }: { dateFrom: string, dateTo: string }): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/winners?dateFrom=${dateFrom}&dateTo=${dateTo}`);
  }

  saveWinner(winner: Winner): Observable<string> {
    return this.http.post<string>(`${this.baseUrl}/update`, winner)
  }

  createNewPromotion(payload: CreatePromotionPayload): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}` + '/api/promotion/new-promotion', payload)
  }

  fetchPromoItems(dateFrom: string, dateTo: string, status: string, region: string, promotionId: number): Observable<any> {
    const reqBody = {
      dateFrom: dateFrom,
      dateTo: dateTo,
      status: status,
      region: region,
      promotionId: promotionId
    }
    return this.http.post<any>(`${environment.apiUrl}/api/promotion-report-upload/run-promotion`, reqBody)
  }


  fetchAllPromotions(): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/api/promotion`)
  }

  createNewVoucher(payload: any): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}` + '/api/promotion/new-vouchers', payload)
  }

  constructor() { }
}
